import type { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export function filterTruthy<T>(source$: Observable<T | null | undefined>): Observable<NonNullable<T>> {
	return <Observable<NonNullable<T>>> <unknown> source$.pipe(
		filter(sourceValue => !!sourceValue),
	);
}
